'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _cancelButton = require('../../../img/cancel-button.png');

var _cancelButton2 = _interopRequireDefault(_cancelButton);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _ItemOptionModal = require('./ItemOptionModal');

var _ItemOptionModal2 = _interopRequireDefault(_ItemOptionModal);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Modal = (0, _createReactClass2.default)({
    displayName: 'Modal',
    getInitialState: function getInitialState() {
        return {};
    },
    componentDidMount: function componentDidMount() {

        $("#" + this.props.id).modal('show');
        $("#" + this.props.id).on('hidden.bs.modal', this.props.handleHideModal);
        $("#" + this.props.id).on('shown.bs.modal', function () {
            $("[data-modalfocus]", this).focus();
        });
    },
    getCrossButtonComponent: function getCrossButtonComponent() {
        if (this.props.dontShowCrossButton) return;

        return _react2.default.createElement(
            'button',
            {
                type: 'button',
                className: 'close close-button-item-add',
                'data-dismiss': 'modal',
                'aria-label': 'Close'
            },
            _react2.default.createElement('img', { src: _cancelButton2.default,
                className: 'cancelButton', alt: "Close Popup" })
        );
    },
    handleConfirm: function handleConfirm() {
        if (this.props.onConfirm) {
            this.props.onConfirm();
        }
    },
    render: function render() {
        var confirmButton = null;
        var cancelButton = null;

        if (this.props.confirm) {
            confirmButton = _react2.default.createElement(_Button2.default, {
                whenClicked: this.handleConfirm,
                className: 'btn-primary',
                title: this.props.confirm,
                subTitleClassName: 'caret'
            });
        }

        if (this.props.cancel) {
            cancelButton = _react2.default.createElement(
                'button',
                {
                    type: 'button',
                    className: 'btn btn-default pull-left',
                    'data-dismiss': 'modal'
                },
                _react2.default.createElement('span', { className: 'glyphicon glyphicon-shopping-cart' }),
                ' ',
                this.props.cancel
            );
        }

        var disableDefaultCloseStyles = {};
        if (this.props.disableDefaultClose) {
            disableDefaultCloseStyles = {
                "data-backdrop": "static",
                "data-keyboard": "false"
            };
        }

        return _react2.default.createElement(
            'div',
            _extends({ className: 'modal fade', id: this.props.id }, disableDefaultCloseStyles, { tabIndex: "-1" }),
            _react2.default.createElement(
                'div',
                { className: 'modal-dialog' },
                _react2.default.createElement(
                    'div',
                    { className: 'modal-content modal-content-add-item' },
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-header' },
                        this.getCrossButtonComponent(),
                        this.props.customTitle ? _react2.default.createElement(
                            'div',
                            { className: 'modal-title-div' },
                            _react2.default.createElement(
                                'h2',
                                { className: 'modal-title text-center' },
                                this.props.title
                            ),
                            _react2.default.createElement(
                                'label',
                                { className: 'modal-sub-title text-center' },
                                this.props.subTitle
                            )
                        ) : _react2.default.createElement(
                            'div',
                            { className: 'modal-title-div' },
                            ' ',
                            _react2.default.createElement(
                                'h2',
                                { className: 'modal-title text-center' },
                                this.props.title
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'modal-body' },
                        this.props.children
                    )
                )
            )
        );
    },


    propTypes: {
        handleHideModal: _propTypes2.default.func.isRequired
    }
});
exports.default = Modal;


//////////////////
// WEBPACK FOOTER
// ./src/components/generic/Modal.jsx
// module id = 545
// module chunks = 0